import React, { useMemo } from 'react';
import Select from 'react-select';
import { selectStyles, AUTOMATION_STATUS_CODES } from '../../utils';
import DateRangePicker from '../common/DateRangePicker/DateRangePicker';
import { MdSearch, MdRefresh } from "react-icons/md";


export default function AutomationsFiltersBar({ draftFilters, setDraftFilters, onSearch, onReset }) {

    const statusValue = useMemo(() => {
        const v = draftFilters.status;
        if (v === '' || v === null || v === undefined) return null;
        return AUTOMATION_STATUS_CODES.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.status]);


    return (
        <div className="list-page-filter-bar">
            <div className="list-page-filter-fields row g-3 align-items-end">
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Automation name"
                        value={draftFilters.name || ''}
                        onChange={(e) =>
                            setDraftFilters((d) => ({ ...d, name: e.target.value }))
                        }
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="automations-status"
                            instanceId="automations-status"
                            classNamePrefix="ns-automations-status"
                            isSearchable
                            isClearable
                            placeholder="Status"
                            aria-label="Status"
                            options={AUTOMATION_STATUS_CODES}
                            value={statusValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, status: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <DateRangePicker
                        dateFrom={draftFilters.dateFrom || ''}
                        dateTo={draftFilters.dateTo || ''}
                        preset={draftFilters.datePreset || ''}
                        onChange={({ dateFrom, dateTo, preset }) =>
                            setDraftFilters((d) => ({
                                ...d,
                                dateFrom: dateFrom || '',
                                dateTo: dateTo || '',
                                datePreset: preset || '',
                            }))
                        }
                        label=""
                        placeholder="Send date"
                        allowClear
                    />
                </div>
                <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
                    <div className="add_app">
                        <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
                            <MdSearch />
                            <span>Search</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
                            <MdRefresh />
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}